/*eslint complexity: off*/
import React, {
  useContext,
  useEffect,
  useState
}                           from 'react';
import { useTranslation }   from 'react-i18next';
import MonetizationOn       from '@material-ui/icons/MonetizationOn';
import {
  partner,
  createPartner,
  editPartner,
}                           from '~/config/routes';
import { toast }            from 'react-toastify';
import { historyPropType }  from '~/config/routerPropTypes';
import { Button }           from '@material-ui/core';
import FileCopyRoundedIcon  from '@material-ui/icons/FileCopyRounded';
import Request              from '~/providers/Request';
import Context              from './context';
import Paper                from '~/components/Paper';
import ModalDelete          from '~/components/ModalDelete';
import InputShow            from '~/components/InputShow';
import PaperButtons         from '~/components/PaperButtons';
import PartnerRecord        from '~/records/PartnerRecord';
import GridContainer        from '~/components/GridContainer';
import GridItem             from '~/components/GridItem';
import Tooltip              from '@material-ui/core/Tooltip';
import { AbilityContext }   from '~/contexts/Can';

const attrName = (attr) => PartnerRecord.hummanAttributeName(attr);

function ShowPartner({history}) {
  const { id } = history.location.route.getParams();
  const { records, addRecords } = useContext(Context);
  const [ record, setRecord ] = useState(new PartnerRecord());
  const { t } = useTranslation();
  const [loading, setLoading] = useState(!records || !records[id]);
  const [modal, setModal] = useState(false);
  const ability = useContext(AbilityContext);

  useEffect(() => {
    if(records && records[id]){
      setRecord(record.updateAttributes(records[id]) );
    }
    setLoading(true);
    Request.get(`/admin/partner/${id}`, {})
      .then( response => {
        setLoading(false);
        addRecords({ data: [response.data] }); //Array para reusar o util de transformar e jogar no contexto.
        setRecord( record.updateAttributes(response.data) );
      })
      .catch( e => {
        console.error(e);
        setLoading(false);
      });
  }, []);

  async function handleDelete(){
    setLoading(true);
    Request.del(`/admin/partner/${id}`)
    .then(() => {
      toast.success(t('delete-toast-success'));
      history.push(partner.spec);
    })
    .catch(() => {
      setLoading(false);
      toast.error(t('delete-toast-fail'));
    });
    setModal(false);
  }

  function handleCopy() {
    const textArea = document.createElement('textarea');

    textArea.value = record.get('api_token');

    document.body.appendChild(textArea);
    textArea.select();

    try {
      const successful = document.execCommand('copy');
      if (successful) {
        toast.success(t('partner.extras.copy_token_success'));
      }
    } catch (err) {
      toast.Error(t('partner.extras.copy_token_fail'));
    }

    document.body.removeChild(textArea);
  }

  return (
    <Paper
      Icon={ MonetizationOn }
      iconColor="blue"
      title={t('partner.defSingular')}
      loading={ loading }
      actions={
        <PaperButtons
          id={ id }
          setModal={ability.can('delete', 'Partners') ? setModal : null}
          backRoute={ partner }
          newRoute={ability.can('new', 'Partners') ? createPartner : null}
          editRoute={ability.can('edit', 'Partners') ? editPartner : null}
        />}
      >
          <GridContainer>
            <GridItem xs={4} md={4}>
              <InputShow
                label={attrName('name')}
                value={record.get('name')}
              />
            </GridItem>
            <GridItem xs={3} sm={3} md={3}>
              <InputShow
                value={record.get('code')}
                label={attrName('code')}
              />
            </GridItem>
            <GridItem xs={2} sm={2} md={2}>
              <InputShow
                value={attrName(record.get('type'))}
                label={attrName('type')}
              />
            </GridItem>
            <GridItem xs={2} sm={2} md={2}>
              <InputShow
                value={record.get('corporation')}
                digObject={['name']}
                type={'object'}
                label={attrName('corporation')}
              />
            </GridItem>
            <GridItem xs={8} sm={8} md={8}>
              <InputShow
                value={record.get('api_token')}
                label={attrName('api_token')}
              />
            </GridItem>
            <GridItem xs={1} sm={1} md={1}>
              <Tooltip title={t('partner.extras.copy_token')} aria-label={t('partner.extras.copy_token')}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => handleCopy()}
                >
                  <FileCopyRoundedIcon />
                </Button>
              </Tooltip>
            </GridItem>
          </GridContainer>
        <ModalDelete
          modal={modal}
          onClose={() => {
            setModal(false);
          }}
          name={record.get('name')}
          id={record.get('id')}
          deleteAction={handleDelete}
        />
      </Paper>
  );
}

  ShowPartner.propTypes={
    history: historyPropType,
  };

export default ShowPartner;
